enum PaymentType {
    CASH = "cash",
    DIRECT_DEBIT = "direct_debit",
    CARD = "card"
}

export default PaymentType;
